import gql from 'graphql-tag';

const CAMPAIGN_ORDER_UNRESOLVED_ISSUES = gql`
  query campaignOrderUnresolvedIssues($campaignOrderId: ID!) {
    campaignOrderIssues(
      where: { campaignOrder: { id: $campaignOrderId }, isResolved: false }
      orderBy: createdAt_DESC
    ) {
      id
      createdAt
      updatedAt
      type
      title
      message
      severity
      firstOccurredAt
      resolvedAt
      isResolved
      campaignOrder {
        id
        name
      }
    }
  }
`;

export default CAMPAIGN_ORDER_UNRESOLVED_ISSUES;
